<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("over_prices") }}</v-toolbar-title>
    </v-toolbar>
    <OverPriceForm :order="order" @on-submit="onSubmit" />
    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      :pathName="
        `airport-car-route-orders/${order.reference_number}/over-prices`
      "
      resName="over_prices"
      class="table-row"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">
          {{ `${item.reason}` }}
        </td>
        <td class="text-sm-center">
          {{ `${item.value}` }}
        </td>

        <td class="text-sm-center">
          {{ convertDate(item.created_at) }}
        </td>
        <td class="text-sm-center">
          <v-btn icon @click="$refs.table_ref.handleDelete(item.id, index)">
            <v-icon color="error" small :title="$t('icon.delete')"
              >mdi-delete</v-icon
            >
          </v-btn>
        </td>
      </template>
    </wrapping-table>
  </main>
</template>

<script>
export default {
  name: "OverPrices",
  components: {
    OverPriceForm: () => import("./OverPriceForm.vue")
  },
  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      headers: ["reason", "value", "created_at", "actions"]
    };
  },
  methods: {
    onSubmit(tableItem) {
      this.$refs.table_ref.addTableItem(tableItem);
    }
  }
};
</script>
